<script>
    export let imageData;
    export let parallax = false;
</script>

{#if parallax}
    <div class="bg-fixed h-screen" style="background-position: top center; background-size: cover; background-image: url({url});"></div>
{:else}
    <img  
        src="{imageData.src}" 
        srcset="{imageData.srcset}"
        sizes="100vw"
        class="bg-fixed"
        alt=""
    >
{/if}